import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO - Per-page title + meta + Open Graph injection for Mundalo.
 *
 * Usage:
 *   <SEO
 *     title="Community"
 *     description="Connect with members building a life abroad."
 *     path="/portal/community"
 *     noindex
 *   />
 */
const SITE_URL = 'https://mundalo.com';
const SITE_NAME = 'Mundalo';
const DEFAULT_DESCRIPTION =
  'Move Abroad. Live Freely. Mundalo is the guided membership for people building a life across borders.';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image,
  noindex = false,
}) => {
  const fullTitle = title && title !== SITE_NAME
    ? `${title} · ${SITE_NAME}`
    : `${SITE_NAME} - Move Abroad. Live Freely.`;
  const canonical = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet title={fullTitle}>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
